import { combineReducers } from '@reduxjs/toolkit';

import salesReducer from 'state/reducers/sales';
import invoicesReducer from 'state/reducers/invoices';

const rootReducer = combineReducers({
  sales: salesReducer,
  invoices: invoicesReducer,
});

export default rootReducer;
